'use strict';

/* jshint -W098 */
angular.module('mean.admin-panel').controller('BuilderAdminHolidaysController', ['$scope', 'Global', 'toaster', 'MeanUser', 'Holidays', '$filter', 'userService',
  function($scope, Global, toaster, MeanUser, Holidays, $filter, userService) {
    $scope.global = Global;
    $scope.package = {
      name: 'holidays'
    };

    $scope.user = MeanUser.user;
    $scope.holidays = {};

    $scope.users = $scope.$parent.division_users;
    var code = userService.getCompanyCode($scope.user.username);
    userService.getMainAccountId($scope.user.username).then(function(success) {
        $scope.main_id = success;
        Holidays.query({'main_account_id': success}, function(holidays) {
            if(holidays.length === 1)
              $scope.holidays = holidays[0].entries;
        });
    }, function(error) {
        toaster.pop('error', 'Holiday Admin Panel', 'There was a problem with getting the holidays from the database');
    });

    $scope.years = ['2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025'];
    var dateFormat = 'yyyy-MM-dd';

    $scope.minDate = new Date();

    $scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 0,
        showWeeks: false
    };

    // Disable weekend selection
    $scope.disabled = function(date, mode) {
        if(mode === 'day') {
            var dates = [];
            $scope.holidays.forEach(function(day) {
                dates.push($filter('date')(day.date, dateFormat));
            });

            if(dates.indexOf($filter('date')(date, dateFormat)) !== -1) {
                return 1;
            }
        }
        return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
    };

    $scope.add = function() {
        if($scope.selectedItem.name && $scope.selectedItem.date) {
            if($scope.holidays.length === 0) {
                var object = [{
                    name: $scope.selectedItem.name,
                    date: $scope.selectedItem.date
                }];

                var holiday = new Holidays({
                    builder: $scope.main_id,
                    holidays: object
                });

                holiday.$save(function(success) {
                    toaster.pop('success', 'Holiday Admin Panel', 'New holiday is saved to the database');
                    $scope.holidays = holiday;
                    $scope.selectedItem.name =
                    $scope.selectedItem.date = '';
                }, function(error) {
                    toaster.pop('error', 'Holiday Admin Panel', 'There was a problem saving the holidays to the database');
                });
            } else {
                var object = {
                    name: $scope.selectedItem.name,
                    date: $scope.selectedItem.date
                };
                $scope.holidays.entries.push(object);
                $scope.holidays.$update(function(success) {
                    toaster.pop('success', 'Holiday Admin Panel', 'Holiday is updated to the database');
                    $scope.selectedItem.name =
                    $scope.selectedItem.date = '';
                }, function(error) {
                    toaster.pop('error', 'Holiday Admin Panel', 'There was a problem saving the holidays to the database');
                });
            }
        }
    };

    $scope.open = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.opened = true;
    };

    $scope.removeDate = function(holiday) {
        var index = $scope.holidays.entries.indexOf(holiday);
        var item = $scope.holidays.entries.splice(index, 1);
        $scope.holidays.$update(function(success) {
            toaster.pop('success', 'Holiday Admin Panel', 'Holiday is removed from the database');
        }, function(error) {
            $scope.holidays.entries.splice(index, 0, item);
            toaster.pop('error', 'Holiday Admin Panel', 'There was a problem removing the holiday from the database');
        });
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/admin-panel/public/controllers/builderAdminHolidays.js